<template>
  <div v-if="record.ref && currentRequests.length && (canAccessRequestLocations || canAccessRequests)">
    <h5 class="mt-3">
      {{ $t('RelatedRequests.linkedApplications') }}
    </h5>
    <ul class="RealisationDetail__RequestList">
      <li
        v-for="request in currentRequests"
        :key="request.uuid"
        class="d-flex align-items-center"
        style="max-width:400px;"
      >
        <router-link
          :is="canAccessRequests ? 'router-link' : 'span'"
          :to="{name: 'RequestDetail', params: { uuid: request.uuid }}"
        >
          {{ request.case_ref }}: <small>{{ request.summary.address }}</small>
        </router-link>
        <i
          v-if="(canAccessRequests && canManageRequest) && ! completed && ! request.limited"
          class="fa-fw fas fa-circle-x text-danger ml-1"
          @click="handleBreakConnection({ uuid: request.uuid })"
        />
      </li>
    </ul>
  </div>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'RelatedRequests',
  props: {
    record: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters('user', [
      'canAccessRequests',
      'canAccessRequestLocations',
      'canManageRequest'
    ]),
    ...mapGetters('requests', [
      'requestByUuid',
    ]),

    completed() {
      try {
        return !! this.record.status.completed
      } catch (e) {
        return false
      }
    },
    currentRequests () {
      return this.record.requestUuids.map(uuid => this.requestByUuid({ uuid })).filter(Boolean)
    },
  },
  methods: {
    ...mapMutations('relations', [
      'setConnectionChange',
    ]),

    handleBreakConnection({ uuid }) {
      const data = {
        type: 'remove',
        requestUuid: uuid,
        realisationUuid: this.record.uuid
      }

      this.setConnectionChange({ data });
      this.$store.dispatch('relations/setRelation', { data })
    },
  },
}
</script>
